import {createContext, Dispatch} from 'react'
import {DEFAULT_PAGED_REPORTS_STATE} from './types/default-paged-reports-state'
import {PagedReportsState} from './types/paged-reports-state'
import {AllActions} from './state/actions'

export const PagedReportsContext = createContext<{
    state: PagedReportsState
    dispatch: Dispatch<AllActions> | undefined
}>({state: DEFAULT_PAGED_REPORTS_STATE, dispatch: undefined})
